import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { ProgramContent, Service } from "../../../../../types/service.type";

import { VideoItem } from "./VideoItem";

const VideosTab = ({ programService }: { programService: Service }) => {
  const { t } = useTranslation("goService", { keyPrefix: "servicePage" });

  const { programContents } = programService;

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.title}>{t("programVideos")}</Typography>
      <VideosList videos={programContents} serviceId={programService!.id} />
    </Box>
  );
};

export default VideosTab;

const VideosList = ({ videos, serviceId }: { videos?: ProgramContent[]; serviceId: number }) => {
  return (
    <Box sx={styles.videosList}>
      {videos?.map((video, index) => (
        <VideoItem key={video.media.id ? `${video.media.id}-${index}` : index} video={video} serviceId={serviceId} />
      ))}
    </Box>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
  },

  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },

  videosList: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
